const NODE_ENV = process.env.NODE_ENV;

if ( !NODE_ENV || NODE_ENV == "development" ) {
  module.exports = {
    start_login_endpoint: "https://apitest.vipps.no/access-management-1.0/access/oauth2/auth",
    token_endpoint: "https://apitest.vipps.no/access-management-1.0/access/oauth2/token",
    userinfo_endpoint: "https://apitest.vipps.no/vipps-userinfo-api/userinfo",
    client_id: '2a5a7cf0-ffdf-4be3-a644-bb85e626ac40',
    scope: 'openid name phoneNumber address birthDate',
    redirect_uri: 'https://opprop.egset.net/auth/vipps/callback',
  };
} else {
  module.exports = {
    start_login_endpoint: "https://api.vipps.no/access-management-1.0/access/oauth2/auth",
    token_endpoint: "https://api.vipps.no/access-management-1.0/access/oauth2/token",
    userinfo_endpoint: "https://api.vipps.no/vipps-userinfo-api/userinfo",
    client_id: 'cfa9c1e9-bc12-4b02-8ad4-e53a23d5c36f',
    scope: 'openid name phoneNumber address birthDate',
    redirect_uri: 'https://opprop.andro.no/auth/vipps/callback',
  };
}
